import { Route } from '@angular/router';
import { AuthGuard } from '@marina/auth';
import { OnboardingGuard } from './guards/onboarding.guard';
import { blockBoatClubGuard } from './guards/block-boat-club.guard';
import { blockDockhandGuard } from './guards/block-dockhand.guard';
import { boatClubOnlyGuard } from './guards/boat-club-only.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
    // Intentionally unguarded: guards/interceptors may redirect here on 403
  },
  
  {
    path: 'resources',
    loadChildren: () =>
      import('./features/resources/resources.module').then(
        (m) => m.ResourcesModule
      ),
    // Public route - no auth required - placed early to match before other routes
  },
  {
    path: 'dry-dock-request',
    loadChildren: () =>
      import('./features/dry-dock-request/dry-dock-request.module').then(
        (m) => m.DryDockRequestModule
      ),
    // Public route - no auth required
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./features/onboarding/onboarding.module').then(
        (m) => m.OnboardingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard, OnboardingGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./features/profile/profile.module').then(
        (m) => m.ProfileModule
      ),
    canActivate: [AuthGuard, OnboardingGuard],
  },
  {
    path: 'authorized-users',
    loadChildren: () =>
      import('./features/authorized-users/authorized-users.module').then(
        (m) => m.AuthorizedUsersModule
      ),
    canActivate: [AuthGuard, OnboardingGuard, blockDockhandGuard],
  },
  {
    path: 'request-launch',
    loadChildren: () =>
      import('./features/launch/launch.module').then(
        (m) => m.LaunchModule
      ),
    canActivate: [AuthGuard, OnboardingGuard],
  },
  {
    path: 'billing',
    loadChildren: () =>
      import('./features/billing/billing.module').then(
        (m) => m.BillingModule
      ),
    canActivate: [AuthGuard, OnboardingGuard, blockBoatClubGuard, blockDockhandGuard],
  },
  {
    path: 'account-security',
    loadChildren: () =>
      import('./features/account-security/account-security.module').then(
        (m) => m.AccountSecurityModule
      ),
    canActivate: [AuthGuard, OnboardingGuard],
  },
  // Legacy routes - redirect to account-security
  {
    path: 'devices',
    redirectTo: '/account-security',
    pathMatch: 'full',
  },
  {
    path: 'sessions',
    redirectTo: '/account-security',
    pathMatch: 'full',
  },
  {
    path: 'docusign/return',
    loadComponent: () =>
      import('./features/dashboard/docusign-return/docusign-return.component').then(
        (m) => m.DocusignReturnComponent
      ),
    canActivate: [AuthGuard, blockBoatClubGuard],
  },
  {
    path: 'not-applicable',
    loadComponent: () =>
      import('./features/boat-club-not-applicable/boat-club-not-applicable.component').then(
        (m) => m.BoatClubNotApplicableComponent
      ),
    canActivate: [AuthGuard, OnboardingGuard, boatClubOnlyGuard],
  },
  {
    path: 'contract',
    loadComponent: () =>
      import('./features/boat-club-not-applicable/boat-club-not-applicable.component').then(
        (m) => m.BoatClubNotApplicableComponent
      ),
    canActivate: [AuthGuard, OnboardingGuard, boatClubOnlyGuard],
  },
  {
    path: 'contracts',
    loadComponent: () =>
      import('./features/boat-club-not-applicable/boat-club-not-applicable.component').then(
        (m) => m.BoatClubNotApplicableComponent
      ),
    canActivate: [AuthGuard, OnboardingGuard, boatClubOnlyGuard],
  },
  {
    path: 'insurance',
    loadComponent: () =>
      import('./features/boat-club-not-applicable/boat-club-not-applicable.component').then(
        (m) => m.BoatClubNotApplicableComponent
      ),
    canActivate: [AuthGuard, OnboardingGuard, boatClubOnlyGuard],
  },
  {
    path: 'renewal',
    loadComponent: () =>
      import('./features/boat-club-not-applicable/boat-club-not-applicable.component').then(
        (m) => m.BoatClubNotApplicableComponent
      ),
    canActivate: [AuthGuard, OnboardingGuard, boatClubOnlyGuard],
  },
  {
    path: 'deposit',
    loadComponent: () =>
      import('./features/boat-club-not-applicable/boat-club-not-applicable.component').then(
        (m) => m.BoatClubNotApplicableComponent
      ),
    canActivate: [AuthGuard, OnboardingGuard, boatClubOnlyGuard],
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
